import { CIcon } from '~/icons/types'

export const ciTrucks: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M23.977 14.77a5.32 5.32 0 0 0-.577-2.372L21 8.223a2.332 2.332 0 0 0-1.958-1.066H14.5V4.742a.5.5 0 0 0-.5-.5H.494a.5.5 0 0 0-.5.5v13.082a.5.5 0 0 0 .5.5h2.82c.117.28.287.535.5.751a2.391 2.391 0 0 0 2.865.36c.363-.209.664-.51.875-.87.035-.078.067-.157.094-.237H14a.5.5 0 0 0 .5-.49l.007-.346h1.068a2.382 2.382 0 0 0 4.758 0h3.177a.502.502 0 0 0 .5-.507l-.033-2.216ZM6.685 18.06a1.394 1.394 0 0 1-2.592-.814 1.392 1.392 0 0 1 1.385-1.278h.074a1.391 1.391 0 0 1 1.133 2.09v.002Zm6.82-.733h-5.65c0-.052.016-.1.012-.154a2.4 2.4 0 0 0-2.26-2.2 2.336 2.336 0 0 0-1.381.352 2.278 2.278 0 0 0-1.112 2H.994V5.242H13.5v2.415l.019 9.217-.013.454Zm9.472-2.546v.121h-.573c-.057 0-.14-.09-.14-.233 0-.142.083-.233.14-.233h.546c.013.12.025.241.027.345Zm-2.162-4.868 1.032 1.8h-4c-.2 0-.258-.03-.206-.036V9.922c.154-.008.387-.008.63-.008h2.544Zm-2.865 8.84a1.392 1.392 0 1 1 .002-2.785 1.392 1.392 0 0 1-.002 2.784Zm2.224-2.26a2.384 2.384 0 0 0-4.447 0h-1.213L14.5 8.155h4.54a1.33 1.33 0 0 1 1.1.586l.1.172h-1.965c-1.086 0-1.63 0-1.63 1.036v1.723c0 .472.208 1.036 1.206 1.036h4.572l.12.21a2.2 2.2 0 0 1 .214.518h-.352a1.237 1.237 0 0 0 0 2.466h.586l.009.595-2.826-.005Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'trucks',
  type: 'thin'
}
